import { render, staticRenderFns } from "./waitPersonDialog.vue?vue&type=template&id=2e498338&scoped=true&"
import script from "./waitPersonDialog.vue?vue&type=script&lang=js&"
export * from "./waitPersonDialog.vue?vue&type=script&lang=js&"
import style0 from "./waitPersonDialog.vue?vue&type=style&index=0&id=2e498338&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e498338",
  null
  
)

export default component.exports